/* ==========================================================================
   Floating button drag helper — Wertheim Center
   Makes the WhatsApp + accessibility floating buttons draggable.
   Persists position per element to localStorage.
   Uses Pointer Events + setPointerCapture so mouse and touch behave the same
   and the browser's native link-drag (the WhatsApp FAB is an <a>) never kicks in.
   ========================================================================== */
(function () {
  'use strict';

  var KEY_PREFIX = 'wertheim_fab_pos_';
  var DRAG_THRESHOLD = 6; // px before a press becomes a drag
  var EDGE_PADDING = 8;

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function applyPos(el, left, top) {
    el.style.left = left + 'px';
    el.style.top = top + 'px';
    el.style.right = 'auto';
    el.style.bottom = 'auto';
  }

  function restorePos(el, key) {
    try {
      var raw = localStorage.getItem(KEY_PREFIX + key);
      if (!raw) return;
      var pos = JSON.parse(raw);
      var w = el.offsetWidth;
      var h = el.offsetHeight;
      var left = clamp(pos.left, EDGE_PADDING, window.innerWidth - w - EDGE_PADDING);
      var top = clamp(pos.top, EDGE_PADDING, window.innerHeight - h - EDGE_PADDING);
      applyPos(el, left, top);
    } catch (e) {}
  }

  function makeDraggable(el, key) {
    if (!el || el.dataset.draggableInit) return;
    el.dataset.draggableInit = '1';

    restorePos(el, key);

    // The <a> FAB would otherwise start a native HTML5 link drag: the ghost
    // sticks to the cursor, our pointer events stop, and the link then opens.
    el.setAttribute('draggable', 'false');
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var startX = 0, startY = 0, origLeft = 0, origTop = 0;
    var pointerId = null, moved = false;

    // Suppress the click that the browser fires right after a drag ends —
    // capture-phase, one drag = one suppressed click, released immediately.
    var suppressClick = false;
    el.addEventListener('click', function (e) {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      }
    }, true);

    el.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      pointerId = e.pointerId;
      moved = false;
      suppressClick = false;
      var rect = el.getBoundingClientRect();
      startX = e.clientX;
      startY = e.clientY;
      origLeft = rect.left;
      origTop = rect.top;
      // Capture so we keep getting moves even when the pointer outruns the
      // button, and so pointerup always reaches us (no stuck drag state).
      try { el.setPointerCapture(pointerId); } catch (err) {}
    });

    el.addEventListener('pointermove', function (e) {
      if (pointerId === null || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!moved && Math.hypot(dx, dy) > DRAG_THRESHOLD) {
        moved = true;
        el.classList.add('is-dragging');
      }
      if (moved) {
        if (e.cancelable) e.preventDefault();
        var w = el.offsetWidth;
        var h = el.offsetHeight;
        var left = clamp(origLeft + dx, EDGE_PADDING, window.innerWidth - w - EDGE_PADDING);
        var top = clamp(origTop + dy, EDGE_PADDING, window.innerHeight - h - EDGE_PADDING);
        applyPos(el, left, top);
      }
    });

    function endDrag(e) {
      if (pointerId === null || e.pointerId !== pointerId) return;
      try { el.releasePointerCapture(pointerId); } catch (err) {}
      pointerId = null;
      if (moved) {
        moved = false;
        el.classList.remove('is-dragging');
        suppressClick = true;
        // Safety valve: if the browser fires no click after this drag, don't
        // let the flag eat the user's NEXT genuine tap.
        setTimeout(function () { suppressClick = false; }, 350);
        try {
          var rect = el.getBoundingClientRect();
          localStorage.setItem(KEY_PREFIX + key, JSON.stringify({ left: rect.left, top: rect.top }));
        } catch (err) {}
      }
    }

    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
  }

  function tick() {
    var wa = document.querySelector('.wa-fab');
    var a11y = document.querySelector('.a11y-trigger');
    if (wa) makeDraggable(wa, 'whatsapp');
    if (a11y) makeDraggable(a11y, 'a11y');
    return wa && a11y;
  }

  function init() {
    if (tick()) return;
    var attempts = 0;
    var poll = setInterval(function () {
      if (tick() || ++attempts > 25) clearInterval(poll); // ~5s max
    }, 200);

    // Re-clamp on resize so a button parked off-screen comes back
    window.addEventListener('resize', function () {
      ['wa-fab', 'a11y-trigger'].forEach(function (cls) {
        var el = document.querySelector('.' + cls);
        if (!el) return;
        var key = cls === 'wa-fab' ? 'whatsapp' : 'a11y';
        restorePos(el, key);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
